import React from "react"
import i18n from "i18n"
import { Typography, Button, Stack } from "@mui/material"
import PropTypes from "prop-types"

const CostHeader = ({ onAddNewCost }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="h6" component="h1">
          {i18n.t("costs.costsGestion")}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <Button variant="contained" color="branded" onClick={onAddNewCost}>
          {i18n.t("costs.newCost")}
        </Button>
      </Stack>
    </Stack>
  )
}

CostHeader.propTypes = {
  onAddNewCost: PropTypes.func.isRequired,
}

export default CostHeader
